
import {
    Labeled, TabbedForm, FormTab, TextInput, ImageInput, ImageField, NumberInput,
    ReferenceInput, SelectInput
} from 'react-admin';
import { Field, change } from 'redux-form'
import AutoComplete from 'material-ui/AutoComplete';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import MaterialTextField from '@material-ui/core/TextField'
import MenuItem from '@material-ui/core/MenuItem';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete'
import React, { Component } from 'react'
import Select from '@material-ui/core/Select'
import { required, minValue, maxValue, notZero } from '../../services/validate'

const hours = []
const minutes = []
for (let i = 0; i < 24; i++) {
    const time = `${i <= 9 ? 0 : ''}${i}`
    hours.push({ id: time, name: time })
}
for (let i = 0; i < 60; i++) {
    const time = `${i <= 9 ? 0 : ''}${i}`
    minutes.push({ id: time, name: time })
}

class NearbyForm extends Component {
    state = { address: '' }

    handleChange = (address) => {
        this.setState({ address })
    }

    handleSelect = (address) => {
        console.log(address)
        geocodeByAddress(address)
            .then(results => getLatLng(results[0]))
            .then(latLng => {
                const { lat, lng } = latLng
                const store = this.form.store
                store.dispatch(change('record-form', 'location', [lat, lng]))
                // console.log('Success', latLng, store.getState())
            })
            .catch(error => console.error('Error', error))
    }

    render() {
        const project = localStorage.getItem('project')
        const { address } = this.state
        return (
            <TabbedForm {...this.props} ref={(ref) => { this.form = ref }}>
                <FormTab label="general">
                    <ReferenceInput disabled label="Project name" defaultValue={project} source="project" reference="project">
                        <SelectInput optionText="name" />
                    </ReferenceInput>
                    <TextInput label="Area info name" source="name" validate={[required()]} />
                    <NumberInput source="rating" validate={[required(), minValue(0), maxValue(5)]} />
                    <ImageInput
                        validate={[required()]}
                        multiple={false}
                        source="image" label="Image" accept="image/*">
                        <ImageField source="url" title="title" />
                    </ImageInput>
                </FormTab>
                <FormTab label="Time">
                    <OpenTimeInput validate={[required()]} source='time' />
                    <CloseTimeInput validate={[required()]} source='time' />
                </FormTab>
                <FormTab label="Location">
                    <TextInput label="Latitude" source="location[0]" validate={[required()]} />
                    <TextInput label="Longitude" source="location[1]" validate={[required()]} />
                    {/* <LatLngInput source='location' /> */}
                    <PlacesAutocomplete
                        value={this.state.address}
                        onChange={this.handleChange}
                        onSelect={this.handleSelect}>
                        {(props) => {
                            const { getInputProps, suggestions, getSuggestionItemProps } = props
                            return (
                                <MuiThemeProvider muiTheme={getMuiTheme({
                                    palette: {
                                        primary1Color: '#303f9f',
                                        primary2Color: '#303f9f',
                                        primary3Color: '#303f9f',
                                    }
                                })}>
                                    <AutoComplete
                                        floatingLabelText="Find your place"
                                        filter={AutoComplete.caseInsensitiveFilter}
                                        onNewRequest={(chosenRequest) =>
                                            getSuggestionItemProps(chosenRequest).onClick()}
                                        onUpdateInput={(searchText) =>
                                            getInputProps().onChange(
                                                { target: { value: searchText } }
                                            )}
                                        dataSource={suggestions}
                                        dataSourceConfig={{
                                            text: 'description',
                                        }}
                                    />
                                </MuiThemeProvider>

                            )
                        }}
                    </PlacesAutocomplete>
                </FormTab>
            </TabbedForm>
        );
    }
}


const OpenTimeInput = (props) => {
    return (
        <Labeled label="Open">
            <span>
                <Field name="time.open.hour" component={hourField} label="latitude" />
                <span style={{ margin: '0 3px 0 3px' }}>:</span>
                <Field name="time.open.minute" component={minuteField} label="longitude" />
            </span>
        </Labeled>
    )
};

const CloseTimeInput = (props) => {
    return (
        <Labeled label="Close">
            <span>
                <Field name="time.close.hour" component={hourField} label="latitude" />
                <span style={{ margin: '0 3px 0 3px' }}>:</span>
                <Field name="time.close.minute" component={minuteField} label="longitude" />
            </span>
        </Labeled>
    )
};

const hourField = ({ input, label, meta: { touched, error }, ...custom }) => (
    <Select {...input} {...custom}>
        {
            hours.map(value => <MenuItem key={value.id} value={value.id} >{value.name}</MenuItem>)
        }
    </Select>
);

const minuteField = ({ input, label, meta: { touched, error }, ...custom }) => (
    <Select {...input} {...custom}>
        {
            minutes.map(value => <MenuItem key={value.id} value={value.id} >{value.name}</MenuItem>)
        }
    </Select>
);

const renderTextField = ({ input, label, meta: { touched, error }, ...custom }) => (
    <MaterialTextField
        hintText={label}
        floatingLabelText={label}
        errorText={touched && error}
        {...input}
        {...custom}
    />
);

const LatLngInput = (props) => {
    return (
        <Labeled label="Location">
            <span>
                <Field name="location[0]" component={renderTextField} label="latitude" />
                &nbsp;
                <Field name="location[1]" component={renderTextField} label="longitude" />
            </span>
        </Labeled>
    )
};

export default NearbyForm


// WEBPACK FOOTER //
// ./src/components/nearby/NearbyForm.js